export default __webpack_public_path__ + "static/media/regulatory--night-speed-limit-85--g1.bfca22ba.png";